import { all, call, put, takeEvery } from "redux-saga/effects";

import {
  getCategoryOptionStart,
  getCategoryOptionSuccess,
  getCategoryOptionFailed,
} from "../redux/getCategoryOption";
import { getCategoryOptionApi } from "core/http/service/timeKeeping";

function* getCategoryOptionWork(action) {
  try {
    const res = yield call(getCategoryOptionApi, action.payload);

    yield put({
      type: getCategoryOptionSuccess.type,
      payload: {
        type: action.payload.categoryType,
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getCategoryOptionFailed.type,
    });
    // toast.error(error?.response?.data?.message || "Đã có lỗi xảy ra!");
  }
}

function* watchGetCategoryOption() {
  yield takeEvery(getCategoryOptionStart.type, getCategoryOptionWork);
}

export default function* getCategoryOptionSaga() {
  yield all([watchGetCategoryOption()]);
}
